<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg
          id="header"
          class="bd-placeholder-img mr-2 rounded"
          width="28"
          height="28"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid slice"
          focusable="false"
          role="img"
          aria-label="Placeholder: 32x32"
        >
          <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>アイコン一覧</h5>
      </div>
      <div class="col-3">
        <button
          id="createRoleBtn"
          type="button"
          class="btn-sm btn-outline-info"
          v-on:click="create"
        >
          新しく登録する
        </button>
      </div>
    </div>
    <div id="main" class="row">
      <div class="col-1"></div>
      <div class="col-6">
        <div class="row">
          <div class="col-10">
            <input
              type="text"
              class="form-control"
              v-model="searchKey"
              @input="renderPage"
              placeholder="ファイル名"
            />
          </div>
        </div>
      </div>
      <div id="sort-inline" class="col-2 form-group form-inline pr-0">
        <img class="sort-solid" src="/sort-alpha-down-solid.svg" />
        <select
          id="sort-select"
          class="form-control"
          v-model="sortKey"
          v-on:change="renderPage()"
        >
          <option value="updatedAt">更新順</option>
          <option value="filName">名前順</option>
        </select>
      </div>
    </div>
    <div id="main" class="row">
      <div class="col-1"></div>
      <div class="col-8">
        <table class="table table-dark table-sm table-hover">
          <thead>
            <tr>
              <th scope="col" style="width: 70px">#</th>
              <th scope="col" style="width: 450px">ファイル名</th>
              <th scope="col">パス</th>
              <th scope="col" style="width: 150px">詳細</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(icon, index) in currentPageIcons" v-bind:key="icon.Key">
              <th scope="row">
                {{ currentIndex * itemsPerPage + index + 1 }}
              </th>
              <td>{{ icon.name }}</td>
              <td>
                <button
                  type="button"
                  class="btn-sm btn-light"
                  v-on:click="copy(icon.Key)"
                >
                  コピー
                </button>
              </td>
              <td>
                <button
                  type="button"
                  class="btn-sm btn-light"
                  v-on:click="detail(icon.name)"
                >
                  詳細
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <nav aria-label="pager">
          <ul class="pagination justify-content-center">
            <li v-if="isPrev" v-on:click="goPrev">
              <a class="btn page-link rounded-pill">&larr; 前</a>
            </li>
            <li v-if="isPrev || isNext" class="mx-2">
              <a class="btn page-link rounded-pill">現在</a>
            </li>
            <li v-if="isNext" v-on:click="goNext">
              <a class="btn page-link rounded-pill">次 &rarr;</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-4"></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { sessions } from '../../mixin/session';
import { path } from '../../mixin/path';
import { headers } from '../../mixin/headers';

export default {
  name: 'Index',
  mixins: [sessions, path, headers],
  props: ['realms'],
  data: function () {
    return {
      icons: [],
      result: [],
      message: '',
      itemsPerPage: 20,
      currentIndex: 0,
      currentPageIcons: [],
      sortKey: 'updatedAt',
      searchKey: '',
      transition: false
    };
  },
  mounted() {
    if (this.$store.getters.hospital.id !== 0) {
      this.list(false);
    }
    if (this.$store.getters.iconDisplayConditions.currentIndex !== 0) {
      this.currentIndex =
        this.$store.getters.iconDisplayConditions.currentIndex;
    }
    if (this.$store.getters.iconDisplayConditions.sortKey !== '') {
      this.sortKey = this.$store.getters.iconDisplayConditions.sortKey;
    }
    if (this.$store.getters.iconDisplayConditions.searchKey !== '') {
      this.searchKey = this.$store.getters.iconDisplayConditions.searchKey;
    }
    this.$store.watch(
      (_, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.list(true);
        }
      }
    );
  },
  computed: {
    isNext: function () {
      return this.icons.length / (this.currentIndex + 1) > this.itemsPerPage;
    },
    isPrev: function () {
      return this.currentIndex !== 0;
    },
    isMessage: function () {
      return this.message.length > 0;
    }
  },
  methods: {
    create() {
      this.$router.replace(
        this.replacePath(this.$cognito, this.realms, '/common/icon/create')
      );
    },
    detail(id) {
      this.$router.replace(
        this.replacePath(
          this.$cognito,
          this.realms,
          '/common/icon/detail/' + id
        )
      );
    },
    goNext() {
      this.transition = true;
      this.currentIndex++;
      this.renderPage();
      this.transition = false;
    },
    goPrev() {
      this.transition = true;
      this.currentIndex--;
      this.renderPage();
      this.transition = false;
    },
    list(isInit) {
      this.$cognito
        .isAuthenticated()
        .then((session) => {
          if (session) {
            if (isInit) {
              this.currentIndex = 0;
            }
            var accessToken = this.getAccessToken(this.$cognito, session);
            var hospitalId = this.$store.getters.hospital.id;
            var hospitalCode = this.$store.getters.hospital.code;
            axios
              .get(`/api/icon/management/${hospitalId}/${hospitalCode}/icons`, {
                headers: this.headers(accessToken)
              })
              .then((response) => {
                this.result = response.data.data.icons;
                this.renderPage();
              })
              .catch((err) => {
                this.message = err.message;
              });
          } else {
            this.$router.replace(
              this.replacePath(this.$cognito, this.realms, '/login')
            );
          }
        })
        .catch((err) => {
          this.message = err.message;
        });
    },
    async copy(path) {
      try {
        await navigator.clipboard.writeText(`/${path}`);
      } catch (err) {
        this.message = err.message;
      }
    },
    renderPage() {
      var startIndex = this.currentIndex * this.itemsPerPage;
      var endIndex = startIndex + this.itemsPerPage;
      if (this.searchKey !== '') {
        this.icons = this.result.filter((item) =>
          item.name.includes(this.searchKey)
        );
        if (this.currentIndex > 0 && !this.transition) {
          this.currentIndex = 0;
          startIndex = this.currentIndex * this.itemsPerPage;
          endIndex = startIndex + this.itemsPerPage;
        }
      } else {
        this.icons = this.result;
      }
      this.currentPageIcons = this.icons
        .sort(
          this.sortKey === 'updatedAt' ? this.compareDates : this.compareTitle
        )
        .slice(startIndex, endIndex);
      this.$store.commit('iconDisplayConditions', {
        sortKey: this.sortKey,
        currentIndex: this.currentIndex,
        searchKey: this.searchKey
      });
    },
    compareDates(a, b) {
      const dateA = new Date(a.LastModified);
      const dateB = new Date(b.LastModified);

      return dateB - dateA;
    },
    compareTitle(a, b) {
      return a.name > b.name ? 1 : -1;
    }
  }
};
</script>
<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
#createRoleBtn {
  float: right;
}
.alert-margin {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.sort-solid {
  height: 25px;
  width: 25px;
  margin-right: 10px;
}
#sort-select {
  width: 70%;
}
</style>
